// @core/api/endpoints/tag/get_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TagResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Get tag by ID
 * Returns a single tag by its ID, including usage count.
 */
export async function GetTag(
  tag_id: string,
  options?: RequestOptions
): Promise<TagResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  const requestOptions = options;
  return client.get<TagResponse>(requestPath, { ...requestOptions });
}
